import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout, { ProtectedRoute } from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import ChannelPartners from "./pages/ChannelPartners";
import SiteVisits from "./pages/SiteVisits";
import Bookings from "./pages/Bookings";
import Inventory from "./pages/Inventory";
import Projects from "./pages/Projects";
import Employees from "./pages/Employees";
import Masters from "./pages/Masters";
import AuditLogs from "./pages/AuditLogs";
import PreSales from "./pages/PreSales";
import Targets from "./pages/Targets";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import Import from "./pages/Import";
import CPDedupe from "./pages/CPDedupe";
import PerformanceReviews from "./pages/PerformanceReviews";
import AdminData from "./pages/AdminData";
import { Marketing, Approvals, Tasks } from "./pages/Simple";
import { Toaster } from "sonner";

function Root() {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors/>
        <Routes>
          <Route path="/" element={<Root/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route element={<ProtectedRoute><Layout/></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="/leads" element={<Leads/>}/>
            <Route path="/clients" element={<Clients/>}/>
            <Route path="/clients/:id" element={<ClientDetail/>}/>
            <Route path="/cps" element={<ChannelPartners/>}/>
            <Route path="/visits" element={<SiteVisits/>}/>
            <Route path="/bookings" element={<Bookings/>}/>
            <Route path="/inventory" element={<Inventory/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/employees" element={<Employees/>}/>
            <Route path="/masters" element={<Masters/>}/>
            <Route path="/audit" element={<AuditLogs/>}/>
            <Route path="/presales" element={<PreSales/>}/>
            <Route path="/marketing" element={<Marketing/>}/>
            <Route path="/targets" element={<Targets/>}/>
            <Route path="/reports" element={<Reports/>}/>
            <Route path="/approvals" element={<Approvals/>}/>
            <Route path="/notifications" element={<Notifications/>}/>
            <Route path="/import" element={<Import/>}/>
            <Route path="/cp-dedupe" element={<CPDedupe/>}/>
            <Route path="/reviews" element={<PerformanceReviews/>}/>
            <Route path="/admin-data" element={<AdminData/>}/>
            <Route path="/tasks" element={<Tasks/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
